import request from "@/plugins/request"

//获取指定父类分类列表
export function getSubCategoryList (parentId) {
    return request({
        url: `api/product/category/${parentId}`,
        method: 'get'
    });
}

//获取专题信息
export function getSubjectInfo (subjectId) {
    return request({
        url: `api/subject/${subjectId}`,
        method: 'get'
    });
}
